import apmic from '@/assets/image-view/brands/apmic.png'
import autogen from '@/assets/image-view/brands/autogen.png'
import breeze from '@/assets/image-view/brands/breeze.svg'
import chandra from '@/assets/image-view/brands/chandra.png'
import chatdev from '@/assets/image-view/brands/chatdev.png'
import comfyui from '@/assets/image-view/brands/comfyui.png'
import deepseek from '@/assets/image-view/brands/deepseek.svg'
import docker from '@/assets/image-view/brands/docker.svg'
import gemma from '@/assets/image-view/brands/gemma.svg'
import glm from '@/assets/image-view/brands/glm.svg'
import gpustack from '@/assets/image-view/brands/gpustack.png'
import laguna from '@/assets/image-view/brands/laguna.svg'
import litellm from '@/assets/image-view/brands/litellm.png'
import llama from '@/assets/image-view/brands/llama.svg'
import llamacpp from '@/assets/image-view/brands/llamacpp.svg'
import llamafactory from '@/assets/image-view/brands/llamafactory.png'
import n8n from '@/assets/image-view/brands/n8n.svg'
import nvidia from '@/assets/image-view/brands/nvidia.svg'
import ollama from '@/assets/image-view/brands/ollama.svg'
import openai from '@/assets/image-view/brands/openai.svg'
import openclaw from '@/assets/image-view/brands/openclaw.svg'
import opencode from '@/assets/image-view/brands/opencode.svg'
import openmpi from '@/assets/image-view/brands/openmpi.png'
import openwebui from '@/assets/image-view/brands/openwebui.svg'
import ornith from '@/assets/image-view/brands/ornith.png'
import pytorch from '@/assets/image-view/brands/pytorch.svg'
import qwen from '@/assets/image-view/brands/qwen.svg'
import ragflow from '@/assets/image-view/brands/ragflow.svg'
import rockylinux from '@/assets/image-view/brands/rockylinux.svg'
import sglang from '@/assets/image-view/brands/sglang.svg'
import ubuntu from '@/assets/image-view/brands/ubuntu.png'
import ultralytics from '@/assets/image-view/brands/ultralytics.svg'
import vllm from '@/assets/image-view/brands/vllm.svg'
import wan from '@/assets/image-view/brands/wan.png'
import windows from '@/assets/image-view/brands/windows.svg'
import glows from '@/assets/images/logo-icon.svg'

import type { ImageBrand } from './imageBrand'

export const IMAGE_BRAND_ICONS: Record<ImageBrand, string> = {
  apmic,
  autogen,
  breeze,
  chandra,
  chatdev,
  comfyui,
  deepseek,
  docker,
  gemma,
  glm,
  gpustack,
  laguna,
  litellm,
  llama,
  llamacpp,
  llamafactory,
  n8n,
  nvidia,
  ollama,
  openai,
  openclaw,
  opencode,
  openmpi,
  openwebui,
  ornith,
  pytorch,
  qwen,
  ragflow,
  rockylinux,
  sglang,
  ubuntu,
  ultralytics,
  vllm,
  wan,
  windows,
  glows,
}
